import React from "react";

export default function PresencePanel({ presence }) {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4">
      <h2 className="text-lg font-semibold text-white mb-4">
        Live Personnel
      </h2>

      <div className="space-y-3">
        {presence.map((user, idx) => (
          <div
            key={idx}
            className="flex items-center justify-between bg-zinc-950 rounded-lg p-3"
          >
            <div>
              <div className="text-white text-sm font-medium">
                {user.user_id}
              </div>

              <div className="text-zinc-400 text-xs">
                {user.role}
              </div>
            </div>

            <div
              className={`text-xs px-2 py-1 rounded-full ${
                user.status === "online"
                  ? "bg-green-500/20 text-green-400"
                  : "bg-zinc-700 text-zinc-300"
              }`}
            >
              {user.status}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
